// extracted by mini-css-extract-plugin
export var error = "user-from-module--error--pzZFq";
export var formSubmitButton = "user-from-module--form-submit-button--PTPh-";
export var hidden = "user-from-module--hidden--wqv71";
export var inputGroup = "user-from-module--input-group--kScEJ";
export var pt5 = "user-from-module--pt-5--vCarg";
export var py0 = "user-from-module--py-0--Iwx4y";
export var registrationForm = "user-from-module--registration-form--V+StK";